import { Observable } from "rxjs";
import { ensureObservable } from "./utilities";

export type SecoPilotingConfigType = {loginUrl: string | Promise<string>, externalCatalogUrl: string | Promise<string>, language: string | Observable<string>}

export class SecoPilotingConfig {

  loginUrl$: Promise<URL>;
  externalCatalogUrl$: Promise<URL>;
  language$: Observable<string>;

  constructor({loginUrl, externalCatalogUrl, language}: SecoPilotingConfigType) {
    this.loginUrl$ = Promise.resolve(loginUrl)
      .then((url) => new URL(url))
      .catch((e) => {
        console.error(`[seco-piloting]: "${loginUrl}" is not a valid url`, e);
        throw e;
      });
    this.externalCatalogUrl$ = Promise.resolve(externalCatalogUrl)
      .then((url) => new URL(url))
      .catch((e) => {
        console.error(`[seco-piloting]: "${externalCatalogUrl}" is not a valid url`, e);
        throw e;
      });
    this.language$ = ensureObservable(language);
  }

}
